import React from "react";
import SelectCountry from "../../components/SelectCountry"


const SelectCountryRoutes = () => {
    return(
        <SelectCountry />
    )
}

export default SelectCountryRoutes